import React from 'react';

export const Footer = () => {
  return (
    <footer className="bg-primary text-white pt-24 pb-12 px-6 md:px-12 border-t border-white/10">
      <div className="max-w-7xl mx-auto flex flex-col items-center text-center">
        <h2 className="text-6xl md:text-9xl font-editorial tracking-tight mb-8">Nirvaana</h2>
        <p className="text-white/50 text-sm tracking-[0.3em] uppercase mb-16">Where nothing goes wrong.</p>
        
        <div className="flex gap-8 mb-24 border-t border-b border-white/10 w-full py-8 justify-center">
          <a href="https://www.instagram.com/events.nirvaana/" target="_blank" rel="noreferrer" className="text-sm uppercase tracking-widest hover:text-secondary transition-colors">Instagram</a>
          <a href="https://wa.me/916350282720" target="_blank" rel="noreferrer" className="text-sm uppercase tracking-widest hover:text-secondary transition-colors">WhatsApp</a>
          <a href="mailto:events.nirvaana@gmail.com" className="text-sm uppercase tracking-widest hover:text-secondary transition-colors">Email</a>
        </div>
        
        <div className="flex flex-col md:flex-row justify-between items-center w-full text-xs text-white/40 uppercase tracking-widest gap-4">
          <p>© {new Date().getFullYear()} Nirvaana Events.</p>
          <p>Designed for Excellence</p>
        </div>
      </div>
    </footer>
  );
};
